<template>
    <div :class="{topLogo:!this.$store.state.isMobile,mtopLogo:this.$store.state.isMobile}">
        <router-link to="/"><img class="logo" src="@/assets/img/topMenu/topLogo.svg" alt=""></router-link>
        <div class="progress" v-if="stepData != '0%' && isShowProgress">
            <div class="bar" :style="{width:stepData}">
            </div>
        </div>
        <el-dropdown trigger="click" class="lang" @command="langChang">
                      <span class="el-dropdown-link">
                        {{lang_text}}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="fr">FR</el-dropdown-item>
                <el-dropdown-item command="en">EN</el-dropdown-item>
                <el-dropdown-item command="es">ES</el-dropdown-item>
                <el-dropdown-item command="it">IT</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
    export default {
        name: "topLogo",
        props: {
            isShowProgress: { //是否显示进度条
                type: Boolean,
                default: false
            }
        },
        computed: {
            stepData() {
                return this.$store.getters.stepData
            }
        },
        data() {
            return {
                lang_text: this.$store.state.lang.toUpperCase()
            }
        },
        mounted() {

        },
        methods: {
            langChang(command) {
                this.lang_text = command.toLocaleUpperCase()
                localStorage.setItem('lang', command)
                let langJson = require(`../assets/source/langV4/langv4.${this.lang_text.toLocaleLowerCase()}.json`)
                this.$store.commit('set', {key: 'langPage', value: langJson})
                this.$store.commit('set', {key: 'lang', value: command})
                // this.$api.menu.getLang({id_langue:command}).then(data=>{
                //     this.$store.commit('set',{key:'langPage',value:data})
                // })
                this.$i18n.locale = command
                window.location.reload()
                // this.langKey++
            },
        }
    }
</script>

<style scoped lang="less">
    .topLogo {
        min-height: .6rem;
        line-height: .6rem;
        text-align: center;
        position: relative;

        .logo {
            width: 156px;
            vertical-align: middle;
            margin-top: 40px;
            margin-bottom: 51px;
        }

        .progress {
            height: .05rem;
            width: 100%;
            background-color: #FFFFFF;
            position: absolute;
            top: 0;

            .bar {
                background-color: #000000;
                transition: width .5s;
                height: 100%;
            }
        }

        .lang {
            color: #000;
            position: absolute;
            right: 5vw;

            .el-dropdown-link {
                font-size: 10pt;
                i {
                    color: #000;
                }
            }

        }
    }

    .mtopLogo {
        text-align: center;
        position: relative;
        padding: 20px 0 0 0;

        .logo {
            width: 20vw;
            vertical-align: middle;
        }

        .progress {
            height: 0.5vw;
            width: 100%;
            background-color: #FFFFFF;
            position: absolute;
            top: 0;

            .bar {
                background-color: #000000;
                transition: width .5s;
                height: 100%;
            }
        }

        .lang {
            color: #000;
            position: absolute;
            right: 5vw;

            .el-dropdown-link {
                font-size: 10pt;
                i {
                    color: #000;
                }
            }

        }
    }
</style>
